import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { GeneratePostService } from '@admin-panel/infra';
import { AdminGameDto, GetAdminGamesForPostResponse } from '@core-http';
import { formatGamePost } from '@ui-components';
import { AppRoutes, DEEP_LINK_TOKEN, DeepLinkProvider, gameLevelMapper, GamesRoutes } from '@core';

export class GetGamesForPostQueryHandler {
  private readonly generatePostService: GeneratePostService = inject(GeneratePostService);
  private readonly deepLinkProvider: DeepLinkProvider = inject(DEEP_LINK_TOKEN);

  query(endDays: number, city: string, radius: number): Observable<string[]> {
    return this.generatePostService
      .getGamesForPost(endDays, city, radius)
      .pipe(map((response: GetAdminGamesForPostResponse) => this.mapToResult(response.games)));
  }

  private mapToResult(games: AdminGameDto[]): string[] {
    return games.map((game: AdminGameDto) => this.formatGame(game));
  }

  private formatGame(game: AdminGameDto): string {
    const level: string = gameLevelMapper[game.level] ?? game.level;
    const url: string = this.deepLinkProvider.generateWebLink(
      `${AppRoutes.GAMES}/${GamesRoutes.SHARED}/${game.gameId}`
    );

    return formatGamePost({
      name: game.name,
      startDate: game.gameDateStart,
      endDate: game.gameDateEnd,
      locationName: game.location.name,
      occupiedSlots: game.occupiedSlots,
      totalSlots: game.totalSlots,
      level,
      priceAmount: +game.priceAmount,
      description: game.description,
      url
    });
  }
}
